import { render } from "./Prompt.vue?vue&type=template&id=ab018852&scoped=true&ts=true"
import script from "./Prompt.vue?vue&type=script&lang=ts"
export * from "./Prompt.vue?vue&type=script&lang=ts"

import "./Prompt.vue?vue&type=style&index=0&id=ab018852&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab018852"]])

export default __exports__